// this style is to keep same look with menuItemTagContainer in getPageMenuItemStyles of
// "@bingads-webui-campaign-react/page-menu" since we're not using the same component
export const NewFeatureTagStyles = {
  menuItemTagContainer: {
    '& .menu-item-tag': {
      color: '#ffffff',
      border: '1px solid #ffffff',
      boxShadow: '0 2px 5px #a19f9d',
      position: 'absolute',
      top: -6,
      right: 0,
      wordBreak: 'normal',
    },
  },
};

